import { Typography } from "@mui/material";
import { PropsWithChildren } from "react";

export function FieldRow(props: PropsWithChildren<{ label: string }>) {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 8, minHeight: 28 }}>
            <Typography variant="caption" color="text.secondary" style={{ width: 72, flexShrink: 0 }}>
                {props.label}
            </Typography>
            <div style={{ flex: 1, minWidth: 0 }}>{props.children}</div>
        </div>
    );
}
